/** Transient map interaction colour; never used as an authored data style. */
export const UI_ACCENT_COLOUR = '#0f4d3e';
